import { EffectiveCart } from 'interfaces/cart';
import { BasicPdProductItem } from 'interfaces/line-item';
import { MinimalCheckoutItem } from 'modules/checkout/order';

export const hasBundles = (
  items: EffectiveCart['items'] | (BasicPdProductItem | MinimalCheckoutItem)[]
): boolean => {
  return items.some(
    (item) => 'bundleRefs' in item && Array.isArray(item.bundleRefs) && item.bundleRefs.length > 0
  );
};
